import styled from "styled-components";
import background from "../assets/background.png";

const EmileDetailsContainer = styled.div`
  width: 70%;
  box-sizing: border-box;
  background-image: url(${background});
  background-repeat: no-repeat;
  background-size: cover;
  padding: 2.5em;

  @media (max-width: 1440px) {
    width: 65%;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    padding 1.5em;

    a {
      font-size: 1.75em;
    }
  }

  h1 {
    color: #673c8c;
    margin: 0;
    margin-bottom: 0.25em;
    font-size: 4em;

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      font-size: 3.5em;
    }
  }
`;

export { EmileDetailsContainer };
